import loadable from '@loadable/component';

export const GradFairsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "GradFairsLinks" */
      './GradFairsLinks.dynamic'
    ),
);
